// extracted by mini-css-extract-plugin
export default {"feeTypeDropdown":"CustomerCustomFeeCard_feeTypeDropdown__ZKkbZ"};